export const PURCHASE_ORDER_INVOICE_TTL_ES = 'Factura de Orden de Compra';

export interface IPurchaseOrderInvoiceBase {
  providerId: string;
  name: string;
  ruc: string;
}

export interface IPurchaseOrderInvoice extends IPurchaseOrderInvoiceBase {
  id: number;
}

export interface ProductsPurchaseOrderInvoiceBody {
  purchaseOrderDetailId: number;
  quantity: number;
}
